import { render } from "./ApiGuideFuneralForm.vue?vue&type=template&id=88fdbe6a&scoped=true"
import script from "./ApiGuideFuneralForm.vue?vue&type=script&lang=js"
export * from "./ApiGuideFuneralForm.vue?vue&type=script&lang=js"

import "./ApiGuideFuneralForm.vue?vue&type=style&index=0&id=88fdbe6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fdbe6a"]])

export default __exports__